import { Box, Button, Paper, Stack, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import BackgroundImage from '../../../../assets/interactive-dashboard.jpg';
import ErrorBoundary from '../../../../components/ErrorBoundary';
import { functions, type AppState } from '../../../../config/store';
import './styles.css';

import { models } from 'powerbi-client';

import { PowerBIEmbed } from 'powerbi-client-react';

import { useEffect, useRef, useState } from 'react';

function InteractiveDashboard() {
  const client = useSelector((state: AppState) => state.firestore.data.client);
  const [reportData, setReportData] = useState<any>();
  const currentReportId = useRef<string | undefined>();

  async function getPbiEmbedData(
    workspaceId?: string,
    reportId?: string,
    useRLS: boolean = false,
  ) {
    if (!workspaceId || !reportId) {
      return;
    }
    const response = await functions.httpsCallable('getPbiEmbedData')({
      clientId: client.id,
      reportId,
      workspaceId,
      useRLS,
    });

    if (response.data) {
      setReportData(response.data.result);
    }
  }

  useEffect(() => {
    if (
      client?.pbiDashboard &&
      currentReportId.current !== client.pbiDashboard.reportId
    ) {
      currentReportId.current = client.pbiDashboard.reportId;
      getPbiEmbedData(
        client.pbiDashboard.workspaceId,
        client.pbiDashboard.reportId,
        client.pbiDashboard.useRLS || false,
      );
    }
  }, [client]);

  return (
    <ErrorBoundary>
      {client ? (
        <Paper
          className="paper-container"
          sx={{
            flex: 1,
            p: 4,
            display: 'flex',
            flexDirection: 'column',
          }}
          id="main-content"
          elevation={2}
        >
          {client?.pbiDashboard ? (
            <Box>
              {reportData && (
                <PowerBIEmbed
                  embedConfig={{
                    type: 'report',
                    id: reportData.id,
                    embedUrl: reportData.embedUrl,
                    accessToken: reportData.token,
                    tokenType: models.TokenType.Embed,
                    settings: {
                      panes: {
                        filters: {
                          visible: false,
                        },
                        pageNavigation: {
                          visible: true,
                        },
                      },
                      background: models.BackgroundType.Transparent,
                    },
                  }}
                  cssClassName={'report-container'}
                />
              )}
            </Box>
          ) : (
            <Stack
              sx={{
                position: 'relative',
                flex: 1,
                backgroundColor: 'red',
              }}
              direction="column"
              alignContent={'center'}
              justifyContent="center"
              alignItems={'center'}
            >
              <>
                <Box
                  component="img"
                  sx={{
                    width: '90%',
                    maxWidth: { xs: 640, sm: 1280 },
                  }}
                  alt="The house from the offer."
                  src={BackgroundImage}
                />
                <Box
                  sx={{
                    position: 'absolute',
                    alignItems: 'center',
                    justifyContent: 'center',
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  <Stack
                    alignItems={'center'}
                    justifyContent="center"
                    sx={{
                      padding: 4,
                      borderRadius: 2,
                      backgroundColor: 'rgba(255, 255, 255, 0.9)',
                      border: '1px solid rgba(0, 0, 0, 0.1)',
                      borderWidth: 2,
                      boxShadow: 2,
                    }}
                  >
                    <Typography
                      color="primary"
                      variant="body1"
                      sx={{ fontWeight: 700 }}
                      mb={2}
                    >
                      Plug your data into a new live interactive dashboard
                    </Typography>
                    <Typography color="primary" variant="body2" mb={2}>
                      Speak to an Asseticom team member for more details
                    </Typography>

                    <Button
                      variant="contained"
                      component="a"
                      href="mailto:sales@asseticom.co.uk?subject=Interactive Dashboard&body=I’d like to find out more about interactive dashboards please..."
                    >
                      Speak To Us
                    </Button>
                  </Stack>
                </Box>
              </>
            </Stack>
          )}
        </Paper>
      ) : (
        <></>
      )}
    </ErrorBoundary>
  );
}

function DashboardIframe({ url }: { url: string }) {
  return (
    <iframe
      width="100%"
      height="100%"
      style={{
        minHeight: 'calc(70vh - 20%)', // Adjust for header height if needed
        border: 'none',
      }}
      src={url}
    ></iframe>
  );
}

export default InteractiveDashboard;
